import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAntePostRaces, STATUSES } from "../../../redux/getReducer/getAntePost";
import { fetchCalender } from "../../../redux/getReducer/getCalender";
import "../../CSS/HomeCSS/blogs.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Bounce, Fade } from "react-reveal";
import { useTranslation } from "react-i18next";
import AntePost from "./AntePost";
import TodayPost from './TodayPost';
import CalenderComponent from './CalenderData';
import Lottie from "lottie-react";
import Animate from "../../../assets/loader.json";
import { BsCalendarDate } from "react-icons/bs";

const Match = ({ setRaceCardData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: CalenderData } = useSelector((state) => state.CalenderData);
  const { data: AntePostRaces } = useSelector((state) => state.AntePostRaces);
  const [activeTab, setActiveTab] = useState("contact");

  useEffect(() => {
    dispatch(fetchCalender());
    dispatch(fetchAntePostRaces());
  }, [dispatch]);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="saddle-battle-currentpost-wrapper w-100">
      <div className="tab-calendar-wrapper">
        <div className="new-calendar-main-card">
          <h2 className="my-new-card-title">{t("CalenderHeading")}</h2>

          <Tabs
            activeKey={activeTab}
            onSelect={handleTabChange}
            id="calendar-tabs"
            className="new-tabs-container"
            mountOnEnter
            transition={false}
          >

            <Tab eventKey="ante" title={t("ante_post")} className="Ante_Post">
              <div className="new-content-area" style={{ display: 'block', minHeight: '100px' }}>
                <AntePost AntePostRaces={AntePostRaces} />
              </div>
            </Tab>
            <Tab eventKey="contact" title={t("Calendar") || "Calendar"}>
              <div className="new-content-area" style={{ display: 'block', minHeight: '100px' }}>
                <CalenderComponent
                  CalenderData={CalenderData}
                  setRaceCardData={setRaceCardData}
                />
              </div>
            </Tab>

          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Match;